<template>
  <layout-main-inner title="鉴定服务">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增鉴定服务
      </el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.serviceName"
          clearable
          placeholder="请输入鉴定服务名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="服务名称"
          min-width="140"
          prop="serviceName">
        </el-table-column>
        <el-table-column
          label="服务概述"
          min-width="400"
          prop="serviceDesc">
        </el-table-column>
        <el-table-column
          label="咨询电话"
          width="120"
          prop="contactPhone">
        </el-table-column>
        <el-table-column
          width="150"
          label="封面">
          <template slot-scope="{ row }">
            <el-image
              style="width:120px"
              :src="row.topImage"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="图文详情"
          width="80">
          <template slot-scope="{ row }">
            <el-popover
              placement="left-start"
              title="图文详情"
              width="240"
              trigger="hover">
              <desc-images v-model="row.detailImagesBak"></desc-images>
              <el-button
                slot="reference"
                type="text">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="145">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-service-modal
      ref="service"
      :callback="() => { getlist() }"
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditServiceModal from './edit-service-modal.vue'
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'LuxuryServicesIndex',
  components: { EditServiceModal, DescImages },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        serviceName: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.service.update({
        luxuryServiceId: row.luxuryServiceId,
        serviceName: row.serviceName,
        contactPhone: row.contactPhone,
        serviceDesc: row.serviceDesc,
        topImage: row.topImage.split(',').map(url => ({ url })),
        detailImages: row.detailImages.split(',').map(url => ({ url, type: 'image', name: url }))
      })
    },
    additem() {
      this.$refs.service.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该鉴定服务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteluxuryservice', {
          payload: {
            luxuryServiceId: row.luxuryServiceId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getluxuryservices', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              detailImagesBak: i.detailImages.split(',').map(url => ({ url, type: 'image', name: url }))
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
